import { render, staticRenderFns } from "./PatternAuthLayout.vue?vue&type=template&id=4605123c&scoped=true&"
import script from "./PatternAuthLayout.vue?vue&type=script&lang=js&"
export * from "./PatternAuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./PatternAuthLayout.vue?vue&type=style&index=0&id=4605123c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605123c",
  null
  
)

export default component.exports